import React from 'react';
import {Field} from 'redux-form/immutable';
import {Card} from 'antd'
import {TextField} from 'redux-form-antd'
import MyReactFiles from "../../../utils/MyReactFiles";

// 移除邊框的樣式
const noBorderStyle = {
    border: 'none',
    outline: 'none',
    boxShadow: 'none'
};

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

// 將函數組件改為類組件
class Guardian1 extends React.Component {
    // 檢查圖片地址是否有效
    handleImageError = (e) => {
        console.log('圖片載入失敗', e.target.src);
        // 如果失敗的圖片不是no-image.png，則顯示預設圖片
        if (!e.target.src.includes('no-image.png')) {
            e.target.src = '/images/no-image.png';
        }
    };

    // 格式化圖片URL，確保路徑正確
    formatImageUrl = (imagePath) => {
        if (!imagePath) return null;
        
        // 如果是完整URL（包含http或https）或是資料URI (base64)，直接返回
        if (imagePath.startsWith('http://') || 
            imagePath.startsWith('https://') || 
            imagePath.startsWith('data:')) {
            return imagePath;
        }
        
        // 否則組合API_SERVER與路徑
        // 確保不會有雙斜線問題
        const baseUrl = API_SERVER.endsWith('/') ? API_SERVER.slice(0, -1) : API_SERVER;
        const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
        const fullUrl = `${baseUrl}${path}`;
        
        console.log('Guardian1 - 組合的圖片URL:', fullUrl);
        return fullUrl;
    };

    render() {
        // 獲取圖片源
        const imgSrc = this.props.guardian1ImgValue ? 
                       (typeof this.props.guardian1ImgValue === 'string' ? 
                        this.formatImageUrl(this.props.guardian1ImgValue) : 
                        this.props.guardian1ImgValue) : 
                       '/images/no-image.png';

        return (
            <Card title='第一接送者' style={{width: '95%'}}>
                <div className="form-group" style={noBorderStyle}>
                    <div className="input-group" style={noBorderStyle}>
                        <label>目前圖片</label>
                        <div style={noBorderStyle}>
                            <img 
                                src={imgSrc} 
                                style={{
                                    maxWidth: '300px', 
                                    maxHeight: '300px', 
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    padding: '5px'
                                }} 
                                alt='guardian1Img'
                                onError={this.handleImageError}
                            />
                        </div>
                        <div className='text-center mt-20' style={{...noBorderStyle, marginTop: '15px'}}>
                            <Field 
                                component={MyReactFiles}
                                name="guardian1Img"
                                onFilesChange={this.props.changGuardian1Img}
                                accept={['image/png', 'image/jpeg']}
                                disabled={this.props.isLocked}
                            />
                        </div>
                    </div>
                </div>
                <Field {...formItemLayout} component={TextField} label="與學生關係"
                      name="guardian1_relationship" type="text"></Field>
            </Card>
        )
    }
}

export default Guardian1



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ParentPassContaioner/TransferStudentForm/Guardian1.jsx